"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestERC1271Wallet__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approveToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "orderSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TestERC1271Wallet__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.TestERC1271Wallet__factory = TestERC1271Wallet__factory;
TestERC1271Wallet__factory.bytecode = _bytecode;
TestERC1271Wallet__factory.abi = _abi;
//# sourceMappingURL=TestERC1271Wallet__factory.js.map